module.exports = __webpack_public_path__ + "static/media/ContactsBg.f1e3d056.png";